function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectListingScore0({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 16,
    viewBox: "0 0 38 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.4164 8C22.4164 3.99594 25.6623 0.75 29.6664 0.75C33.6704 0.75 36.9164 3.99594 36.9164 8C36.9164 12.0041 33.6704 15.25 29.6664 15.25C25.6623 15.25 22.4164 12.0041 22.4164 8Z",
    fill: "#D5D6D8",
    stroke: "white",
    style: {
      fill: "#D5D6D8",
      fill: "color(display-p3 0.8353 0.8392 0.8471)",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0837 8C17.0837 3.99594 20.3296 0.75 24.3337 0.75C28.3377 0.75 31.5837 3.99594 31.5837 8C31.5837 12.0041 28.3377 15.25 24.3337 15.25C20.3296 15.25 17.0837 12.0041 17.0837 8Z",
    fill: "#D5D6D8",
    stroke: "white",
    style: {
      fill: "#D5D6D8",
      fill: "color(display-p3 0.8353 0.8392 0.8471)",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.751 8C11.751 3.99594 14.9969 0.75 19.001 0.75C23.0051 0.75 26.251 3.99594 26.251 8C26.251 12.0041 23.0051 15.25 19.001 15.25C14.9969 15.25 11.751 12.0041 11.751 8Z",
    fill: "#D5D6D8",
    stroke: "white",
    style: {
      fill: "#D5D6D8",
      fill: "color(display-p3 0.8353 0.8392 0.8471)",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.41635,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 7.25,
    fill: "#D5D6D8",
    stroke: "white",
    style: {
      fill: "#D5D6D8",
      fill: "color(display-p3 0.8353 0.8392 0.8471)",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.08368,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 7.25,
    fill: "#D5D6D8",
    stroke: "white",
    style: {
      fill: "#D5D6D8",
      fill: "color(display-p3 0.8353 0.8392 0.8471)",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectListingScore0);
export default __webpack_public_path__ + "static/media/project-listing-score-0.03463eadbaab4812154e522d176c7ab0.svg";
export { ForwardRef as ReactComponent };